module.exports = __webpack_public_path__ + "static/media/kverneland-isobus.9250ced1.png";